import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LanguageGuard } from "./services/language.guard";

const routes: Routes = [
  {
    path: ':lang',
    children: [
      {path: '', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)},
      {
        path: 'privacy-policy',
        loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
      },
      {
        path: 'terms-and-conditions',
        loadChildren: () => import('./pages/terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule)
      },
      {
        path: 'henter-pant',
        loadChildren: () => import('./pages/henter-pant/henter-pant.module').then(m => m.HenterPantModule)
      },
      {
        path: 'teams',
        loadChildren: () => import('./pages/team/team.module').then(m => m.TeamModule)
      },
      {
        path: 'players',
        loadChildren: () => import('./pages/player/player.module').then(m => m.PlayerModule)
      },
      {path: '**', loadChildren: () => import('./pages/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule)},
    ],
    canActivate: [LanguageGuard]
  },
  { path: '', redirectTo: 'no', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
